import { Box, Button, Card, Typography } from "@mui/material";
import { Flex, HStack, colors } from "@zfp-akademie-a-s/zfp-design";
import { ChevronRightIcon, EditIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

type Props = {
  readonly onClick: () => void;
};

export const InvestmentsNsureCustomSolutionPanel = ({ onClick }: Props) => {
  const { t } = useResource();

  return (
    // the package's card with its thin border, in the radius of the portfolio cards under it (SelectableOption's)
    <Card sx={{ px: Spacing.XL, py: Spacing.L, borderRadius: Radius.M }}>
      <HStack alignItems="center" gap={Spacing.L} flexWrap="wrap">
        <Flex
          alignItems="center"
          justifyContent="center"
          width={40}
          height={40}
          flexShrink={0}
          bgcolor={colors.brandLight}
          borderRadius={Radius.M}
        >
          <EditIcon sx={{ fontSize: 20, color: "primary.main" }} />
        </Flex>

        <Box flex={1} minWidth={220}>
          <Typography variant="body1" fontWeight={700}>
            {t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.SolutionSelect.CustomSolution)}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.SolutionSelect.CustomSolutionDescription)}
          </Typography>
        </Box>

        <Button
          variant="contained"
          color="secondary"
          onClick={onClick}
          endIcon={<ChevronRightIcon fontSize="small" sx={{ position: "relative", top: "-1px" }} />}
        >
          {t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.SolutionSelect.CustomSolutionAction)}
        </Button>
      </HStack>
    </Card>
  );
};
